export const resolveCanonicalChapterNumber = (chapter: any): number => {
  if (!chapter || typeof chapter !== 'object') return NaN;

  // 1. valid numeric chapterNumber
  if (typeof chapter.chapterNumber === 'number' && !isNaN(chapter.chapterNumber) && chapter.chapterNumber > 0) {
    return chapter.chapterNumber;
  }

  // 2. valid numeric order
  if (typeof chapter.order === 'number' && !isNaN(chapter.order) && chapter.order > 0) {
    return chapter.order;
  }

  // 3. numeric-string chapterNumber
  if (typeof chapter.chapterNumber === 'string') {
    const parsed = Number(chapter.chapterNumber);
    if (!isNaN(parsed) && parsed > 0) return parsed;
  }

  // 4. numeric-string order
  if (typeof chapter.order === 'string') {
    const parsed = Number(chapter.order);
    if (!isNaN(parsed) && parsed > 0) return parsed;
  }

  // 5. valid numeric id
  if (typeof chapter.id === 'number' && !isNaN(chapter.id) && chapter.id > 0) {
    return chapter.id;
  }

  // 6. trailing numeric suffix from a string id using /(\d+)$/
  if (typeof chapter.id === 'string') {
    const match = chapter.id.match(/(\d+)$/);
    if (match) {
      const parsed = parseInt(match[1], 10);
      if (!isNaN(parsed) && parsed > 0) return parsed;
    }
  }

  // 7. unresolved if none applies
  return NaN;
};
